export default "__VITE_ASSET__jiwBnUF2__"